/*
 * File: 美信下载提示页
 * File Created: 2021-05-13 10:14:21 am
 * Author: huangxl (huangxl20@meicloud.com)
 * -----
 * Last Modified: 2021-06-24 2:34:46 pm
 * Modified By: huangxl (huangxl20@meicloud.com)
 */

<template>
  <div
    :class="[
      'mission-tips',
      isPC ? 'mission-tips-pc' : 'mission-tips-mb'
    ]">
    <div class="container">
      <div class="app-icon">
        <img v-if="pageType==='mx'" src="../../assets/images/icons/mission.png" alt="" width="60" height="60">
        <img v-else src="../../assets/images/icons/TXMeeting.png" alt="" width="60" height="60">
        <span>{{ getPageContent.openText }}</span>
      </div>
      <div class="text-wrapper">
        <span class="text">{{ ` ${$t('common.or')} ` }} <span class="blue" @click="back">{{ $t('meeting.back') }}</span>{{ getPageContent.line2 }}</span>
        <span class="text">
          {{ getPageContent.line3 }}
          <span
            class="blue"
            @click="handleOpenDownload">
            {{ $t('meeting.clickHere') }}
          </span>
        </span>
        <span class="text">{{ getPageContent.line4 }}</span>
      </div>
      <mx-button
        type="info"
        block
        @click="goToDownloadMission">
        {{ getPageContent.download }}
      </mx-button>
      <div class="text-wrapper bottom" v-if="pageType!=='mx'">
        <span>{{ $t('meeting.isNotChinesePhone') }}</span>
        <a :href="toDownloadVooV" target="_blank" v-if="$i18n.locale === 'zh-CN'">{{
          $t("meeting.downloadVooV")
        }}</a>
        <a :href="toDownloadTXMeeting" target="_blank" v-if="$i18n.locale !== 'zh-CN'">{{
          $t("meeting.downloadVooV")
        }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import MxButton from '@/components/mx-button'
import Config from "@/config";

import {
  isPC,
  genrateMissionOpenUrl,
  getMissionDownloadUrl,
  genrateMissionOpenWXUrl,
  getTXMeetingDownloadUrl
} from '@/utils'
export default {
  name: 'mission-tips',
  components: {
    MxButton
  },
  data () {
    return {
      isPC: isPC()
    }
  },
  computed: {
    meetingUuid() {
      return this.$route.query.meetingUuid
    },
    meetingNo() {
      return this.$route.query.meetingNo
    },
    secure() {
      return this.$route.query.secure
    },
    resource() {
      return this.$route.query.resource
    },
    pageType() {
      return this.$route.query.type
    },
    getPageContent() {
      const data = {
        mx: {
          openText: this.$t('meeting.openMission'),
          line2: this.$t('meeting.clickDownloadMission'),
          line3: this.$t('meeting.installedMission'),
          line4: this.$t('meeting.openMissionTips'),
          download: this.$t('meeting.donwloadMissionImed'),
        },
        tx: {
          openText: this.$t('meeting.openTXMeeting'),
          line1: this.$t('meeting.clickDownloadTXMeeting'),
          line2: this.$t('meeting.needTXMeeting'),
          line3: this.$t('meeting.installedTXMeeting'),
          line4: this.$t('meeting.openTXMeetingTips'),
          download: this.$t('meeting.donwloadTXMeetingImed'),
        }
      }
      return data[this.pageType]
    },
    toDownloadVooV() {
      return Config.toDownloadVooV;
    },
    toDownloadTXMeeting() {
      return Config.toDownloadTXMeeting;
    },
  },
  methods: {
    back(){
      this.$router.back()
    },
    handleOpenDownload(){
      if(this.pageType === 'mx') {
        this.handleOpenMission()
      }else{
        this.handleOpenTXMeeting()
      }
    },
    handleOpenMission() {
      this.$_dataRanger.send('button_click', {
        module: '视频会议',
        sub_module: '会议中转页',
        page_name: '会议中转页',
        page_path: '会议中转页',
        element_content: '美信入会'
      })
      // 添加会议标识：0：默认zoom标识尚阳会议 1：TM表示腾讯会议
      let missionSchemeUrl = genrateMissionOpenUrl(this.meetingUuid, this.secure, this.resource)
      window.location.replace(missionSchemeUrl)
    },
    handleOpenTXMeeting() {
      let missionSchemeUrl = genrateMissionOpenWXUrl(this.meetingNo, this.resource);
      console.log('腾讯的链接----', missionSchemeUrl)
      window.location.replace(missionSchemeUrl);
      this.$router.push({
        name: "mission",
        query: {
          meetingNo: this.meetingNo,
          type: 'tx',
        },
      });
    },
    async goToDownloadMission() {
      if(this.pageType === 'mx') {
        this.$_dataRanger.send('button_click', {
          module: '视频会议',
          sub_module: '会议中转页',
          page_name: '会议中转页',
          page_path: '会议中转页',
          element_content: '下载美信'
        })
        let url = getMissionDownloadUrl()
        url && window.location.replace(url)
      }else{
        // this.$_dataRanger.send('button_click', {
        //   module: '视频会议',
        //   sub_module: '会议中转页',
        //   page_name: '会议中转页',
        //   page_path: '会议中转页',
        //   element_content: '下载美信'
        // })
        let url = getTXMeetingDownloadUrl(this.$i18n.locale)
        url && window.location.replace(url)
      }
    }
  }
}
</script>

<style lang='less' scoped>
  @import '~@/assets/less/home.less';
  .mission-tips {
    .app-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 40px 0 27px 0;
      font-size: 14px;
      & > img {
        margin-bottom: 20px;
      }
      & > span {
        font-size: 18px;
        font-weight: 500;
        line-height: 25px;
        text-align: center;
      }
    }
    .text-wrapper {
      display: flex;
      flex-direction: column;
      // align-items: center;
      font-size: 14px;
      line-height: 22px;
      color: #7F7F7F;
      margin-bottom: 32px;
      text-align: center;
      .title {
        color: #333333;
      }
      .blue {
        color: #0086FF;
        &:hover {
          cursor: pointer;
          color: #2496FF;
        }
      }
    }

    .bottom {
      margin-top: 16px;
    }
    /deep/ .van-nav-bar {
      background: #F2F2F2;
      .van-icon {
        color: #545454;
      }
      .van-nav-bar__left {
        padding-left: 0;
      }
    }
  }
</style>
